import React, { useState } from 'react';
import { Box, Grid, Card, CardContent, FormControl, FormHelperText, Typography } from '@deere/fuel-react';
import { FormSelect } from "../shared/FormSelect";
import TextField from "@material-ui/core/TextField";
import { Controller } from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useAuthConfig } from "../shared/helper";
import {
    FUNCTIONAL_AREA,
    SELECT_SUPPLIER_ERROR_MSG,
    SUB_FUNCTIONAL_AREA,
    SUPPLIER,
    SUPPLIER_LOCATION
} from "../shared/Constants";
export const SupplierInfoCard = ({ supplierData, supplierNum, control, isDisabled, errorMsg, subFunctionalAreas, isSupplierNumberEmpty, onSubfunctionalAreaChange, onOptionsChange }) => {
    let authAxios = useAuthConfig();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSubFunctionalArea = event => {
        onSubfunctionalAreaChange(event.target.value);
    }

    const handleValueChange = (value) => {
        onOptionsChange(value)
    }

    const getSuppliersList = async (value) => {
        setLoading(true)
        try {
            await authAxios.get(`/suppliers?queryString=${value}`).then(res => {
                setOptions(res.data)
                setLoading(false)
            })
        } catch (e) {
            console.error(e);
            setLoading(false)
        }
    };


    return (
        <Grid item xs={12}>
            <Card>
                <CardContent style={{ minHeight: '8rem' }}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Typography variant="label">{SUPPLIER} &nbsp;
                                <span
                                    aria-label="required field"
                                    className="uxf-is-required"
                                >
                                    *
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            {(supplierData.supplierNumber !== "" || errorMsg !== "") && (
                                <Box ml={4}>
                                    <Typography variant="label">{SUPPLIER_LOCATION}</Typography>
                                </Box>
                            )}
                        </Grid>
                        <Grid item xs={12} md={8}>
                            {supplierNum ? (<>
                                <Typography variant="body1" gutterBottom>
                                    {supplierData.supplierName ? `${supplierData.supplierName} - ${supplierNum}` : `${supplierNum}`}
                                </Typography>
                            </>) : <Box mb={4}>
                                <FormControl fullWidth required error component="fieldset">
                                    <Controller
                                        rules={{ required: true }}
                                        control={control}
                                        name="supplier"
                                        render={({ onChange, value }) => (
                                            <Autocomplete
                                                size="small"
                                                id="supplier"
                                                options={options}
                                                getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}`}
                                                getOptionSelected={(option, value) => option.supplierNumber === value.supplierNumber}
                                                loading={loading}
                                                onChange={(e, value) => {
                                                    handleValueChange(value)
                                                }}
                                                onInputChange={(e, value) => {
                                                    if (value.length > 2)
                                                        getSuppliersList(value)
                                                }}
                                                renderInput={(params) => <TextField {...params}
                                                    placeholder="Search Supplier name or number (enter 3 or  characters)"
                                                    variant="outlined" />}
                                            />
                                        )}
                                    />
                                    <FormHelperText>{isSupplierNumberEmpty && SELECT_SUPPLIER_ERROR_MSG}</FormHelperText>
                                </FormControl>
                            </Box>}
                        </Grid>
                        <Grid item xs={12} md={4}>
                            {(supplierData.supplierNumber !== "" || errorMsg !== "") && (
                                <Box ml={4}>
                                    <Typography variant="body1" mb={4}>
                                        {supplierData.location !== "" ? supplierData.location : "-"}
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                        {(supplierData.supplierNumber !== "" || errorMsg !== "") && (
                            <>
                                <Grid item xs={12} md={4}>
                                    <Typography variant="label">{FUNCTIONAL_AREA}</Typography>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <Typography variant="label">{SUB_FUNCTIONAL_AREA} &nbsp;
                                        <span
                                            aria-label="required field"
                                            className="uxf-is-required"
                                        >
                                            *
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography variant="body1" gutterBottom>
                                        {supplierData.functionalAreaType ? `${supplierData.functionalAreaType}` : '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormSelect
                                        label={"Sub Functional Area"}
                                        defValue={supplierData.subFunctionalAreaId ? supplierData.subFunctionalAreaId : supplierData.subFunctionalAreaId}
                                        name={"subFunctionalAreas"}
                                        options={subFunctionalAreas}
                                        onTypeChange={handleSubFunctionalArea}
                                        control={control}
                                        required={true}
                                        showLabel={false}
                                        isDisabled={isDisabled}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
}
